import React from "react";
interface IProps {
  children: React.ReactNode;
}

export const TierButton = ({ children }: IProps) => {
  return <div className="cw-w-full cw-my-4 cw-flex cw-flex-col"> {children}</div>;
};
